import { render, staticRenderFns } from "./WaitingForReception.vue?vue&type=template&id=2e7b79ee"
import script from "./WaitingForReception.vue?vue&type=script&lang=js"
export * from "./WaitingForReception.vue?vue&type=script&lang=js"
import style0 from "./WaitingForReception.vue?vue&type=style&index=0&id=2e7b79ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports